/* Zetavax 2026-09-18: se define product-modal solo cuando ModalDialog ya existe. */
(function () {
  function definir() {
    if (typeof ModalDialog === 'undefined') return false;
    if (customElements.get('product-modal')) return true;
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() { super(); }
      hide() { super.hide(); }
      show(opener) { super.show(opener); this.showActiveMedia(); }
      showActiveMedia() {
        this.querySelectorAll('[data-media-id]').forEach((element) => {
          if (element.getAttribute('data-media-id') !== this.openedBy.getAttribute('data-media-id')) {
            element.classList.remove('active');
          }
        });
        const activeMedia = this.querySelector('[data-media-id="' + this.openedBy.getAttribute('data-media-id') + '"]');
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
        const container = this.querySelector('[role="document"]');
        if (container) container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube')) {
          activeMedia.loadContent();
        }
      }
    });
    return true;
  }
  if (!definir()) {
    document.addEventListener('DOMContentLoaded', definir);
    var intentos = 0;
    var t = setInterval(function () { if (definir() || ++intentos > 200) clearInterval(t); }, 50);
  }
})();

/* Zetavax 2026-09-18 - red de seguridad del precio: si Kaching Bundles no pinta
   sus barras (producto sin deal, app caida, scripts bloqueados), se vuelve a
   mostrar el precio nativo del tema para que la ficha nunca quede sin precio. */
(function () {
  if (!/\/products\//.test(location.pathname) && !/products_preview/.test(location.pathname)) return;
  function kachingPinto() {
    var b = document.querySelector('.kaching-bundles__block--loaded, .kaching-bundles__bars');
    return !!(b && b.offsetHeight > 0);
  }
  function mostrar() {
    document.querySelectorAll('.price-list').forEach(function (el) {
      el.style.setProperty('visibility', 'visible', 'important');
      el.setAttribute('data-zv-precio-fallback', '1');
    });
  }
  function ocultar() {
    document.querySelectorAll('.price-list[data-zv-precio-fallback]').forEach(function (el) {
      el.style.removeProperty('visibility');
      el.removeAttribute('data-zv-precio-fallback');
    });
  }
  function revisar() { if (kachingPinto()) ocultar(); else mostrar(); }
  var n = 0;
  var reloj = setInterval(function () { revisar(); if (++n > 12) clearInterval(reloj); }, 500);
  document.addEventListener('DOMContentLoaded', revisar);
  window.addEventListener('load', revisar);
})();
